<div class="recent-project-trend">
  <div class="mat-subheading-2" fxLayout fxLayoutGap="4px" fxLayoutAlign="start cetner">
    <mat-icon>queue_music</mat-icon>
    <div>
      <span>最新作品動向</span>
      <span class="date-range">
        リリースから {{ today | date: 'yyyy-MM-dd' }} までの集計データ
      </span>
    </div>
    <mat-icon
      class="help"
      matTooltip='フィジカル売上枚数（NET）、ストリーム数、アルバムダウンロード数、トラックダウンロード数はリリース日からの合計数です。
      アルバム換算数は、フィジカル・ストリーム・ダウンロードのアルバム換算数の合計です。
      作品は、UM Consumptionの"Project" に該当します。"Project"には、アルバム・シングル・maxiなどが含まれますが、"Project"の作られ方により表示されるべきものが異なる場合があります。ご要望・不明点あれば、画面上部のアドレスより、ご連絡ください。'
      >help_outline</mat-icon
    >
  </div>
  <app-project-sale
    [projectSale]="projectSale$ | async"
    [loading]="loading$ | async"
  ></app-project-sale>
</div>
